/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatAcceptedMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACCEPTED);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler'] = com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ChatAcceptedMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler
 * @param {com.inq.flash.messagingframework.Message} message - message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.prototype.processMessage = function (message) {
	/** @type {boolean} */
	var forReconnect = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_FOR_RECONNECT);
	/** @type {string} */
	var agentID = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID);
	/** @type {string} */
	var currentAgentID = com.inq.flash.client.control.FlashPeer.getAgentID();
	/** @type {boolean} */
	var isLastAssignedMessage = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_LAST_AGENT_ASSIGNED_MESSAGE);
	/** @type {boolean} */
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) === "1";

	var isVirtual = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_EVENT_AGENT_IS_VIRTUAL) === "true" 
	if (isVirtual) {
		com.inq.flash.client.control.PersistenceManager.SetValue(VIRTUAL_AGENT, 1, true, true);
	}

	this.setAgent(agentID, message);

	/*
	 * same conditions as in ClientApplicationMessageHandler#setAgent,
	 * because "onChatAccepted" should be fired once for same agent
	 */
	if (agentID && (!replay || (isLastAssignedMessage && agentID !== currentAgentID))) {
		Application.application.fireMxmlEvent("onChatAccepted");
	}

	if (!replay) {
		this.getController().sendFirstQueuedMessage(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TIME_LOG));
		this.getController().setQueueMessages();
		this.getController().checkForChatExit();
		this.getController().setConnectionAccepted(true);

		if (!forReconnect) {
			/** @type {Object} */
			var auxParams = { Agent: true };
			com.inq.flash.client.control.FlashPeer.setSurveyAuxParams(auxParams);

			if (com.inq.flash.client.control.FlashVars.getValue("enableAgentEncryptData") === "true") {
				var siteID = com.inq.flash.client.control.FlashVars.getValue("siteID");
				var tsRequest, tagServerURLPath, tsRequestURL;
				var publicAgentId = message.getProperty("public_user_id");
				if (publicAgentId) {
					tagServerURLPath = "tagserver/secure-agent-data/public-agent-id/" + publicAgentId + "?siteId=" + siteID;
					tsRequestURL = Std.string(com.inq.flash.client.control.FlashVars.getValue("tagServerBaseURL")) + tagServerURLPath;

					this.agentEncryptedDataLoader = new com.inq.net.URLLoader;
					tsRequest = new com.inq.net.URLRequest(tsRequestURL);
					this.agentEncryptedDataLoader.addEventListener(com.inq.events.Event.NETWORK_ERROR, $bind(this, this.agentEncrypteDataFailed));
					this.agentEncryptedDataLoader.addEventListener(com.inq.events.Event.COMPLETE, $bind(this, this.agentEncrypteDataLoaded));
					this.agentEncryptedDataLoader.load(tsRequest);
				}
			}
		} else {
			this.getController().sendCommunicationMessagesFromQueue();

			if (!this.getController().getChat().isAsyncReconnect()) {
				this.getController().restoreTranscript();
			}

			this.getController().getChat().setAsyncReconnect(false);
		}
	}
};

com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.prototype.agentEncryptedDataLoader = null;
com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.prototype.agentEncrypteDataFailed = function(data) {
	haxe.Log.trace("ChatAcceptedMessageHandler.agentEncrypteDataLoader request failed",{ fileName : "ChatAcceptedMessageHandler.js", lineNumber : 69,
		className : "com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler", methodName : "agentEncryptedDataLoader"});
	return;
};
com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.prototype.agentEncrypteDataLoaded = function(data) {
	if (this.agentEncryptedDataLoader.data) {
		top.CHAT_AGENT_ENCRYPTED_DATA = {};
		for (keyName in this.agentEncryptedDataLoader.data) {
			if (keyName !== "secureAgentAttributes") {
				top.CHAT_AGENT_ENCRYPTED_DATA[keyName] = this.agentEncryptedDataLoader.data[keyName];
			}
		}
		top.CHAT_AGENT_ENCRYPTED_DATA.secureAgentAttributes = {};

		if (this.agentEncryptedDataLoader.data.secureAgentAttributes) {
			for (var i = 0; i < this.agentEncryptedDataLoader.data.secureAgentAttributes.length; i++) {
				if (typeof top.CHAT_AGENT_ENCRYPTED_DATA.secureAgentAttributes[this.agentEncryptedDataLoader.data.secureAgentAttributes[i].key] === "undefined") {
					top.CHAT_AGENT_ENCRYPTED_DATA.secureAgentAttributes[this.agentEncryptedDataLoader.data.secureAgentAttributes[i].key] = [];
				}
				top.CHAT_AGENT_ENCRYPTED_DATA.secureAgentAttributes[this.agentEncryptedDataLoader.data.secureAgentAttributes[i].key].push(this.agentEncryptedDataLoader.data.secureAgentAttributes[i].secureValue);
			}
		}
	}
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatAcceptedMessageHandler;
